import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import { siteConfig } from "../config/site";
import { siteRoutes } from "../routes";

const links = [
  { to: siteRoutes.home, label: "Home" },
  { to: siteRoutes.download, label: "Download" },
  { to: siteRoutes.support, label: "Support" },
] as const;

export function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page not found · {siteConfig.name}</title>
      </Helmet>

      <section className="pb-16">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">404</p>
        <h1 className="mt-3 font-display text-4xl tracking-tight sm:text-5xl">Page not found</h1>
        <p className="mt-4 max-w-xl text-muted-foreground">
          That address doesn&apos;t point to a page on {siteConfig.name}.
        </p>
        <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3 text-sm">
          {links.map((link) => (
            <Link
              className="text-muted-foreground underline underline-offset-4 hover:text-foreground"
              key={link.to}
              to={link.to}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
